module.exports = __webpack_public_path__ + "static/media/cross-green-big.5f0bdea0.svg";